import React, { useEffect, useState } from "react";
import { LivepeerConfig, useStream } from "@livepeer/react";
import { livepeerClient } from "../../features/live-streaming/livepeer";
import LoadingSpinner from "../LoadingSpinner";

const LivepeerWrapper = ({ streamId, poster, publishedDate }) => (
  <div className="flex justify-center w-full">
    <LivepeerConfig client={livepeerClient}>
      <LiveStream streamId={streamId} poster={poster} publishedDate={publishedDate} />
    </LivepeerConfig>
  </div>
);

const LiveStream = ({ streamId, poster, publishedDate }) => {
  const { data: stream, refetch } = useStream(streamId);

  useEffect(() => {
    const interval = setInterval(refetch, 3000);
    return () => clearInterval(interval);
  });

  if (!stream) return <LoadingSpinner />;
  if (!stream?.isActive)
    return <LiveStreamInactive poster={poster} publishedDate={publishedDate} />;
  return (
    <iframe
      src={`https://lvpr.tv?v=${stream.playbackId}`}
      title="livestream"
      className="w-screen h-screen"
      frameborder="0"
      allowfullscreen
      objectfit="contain"
      allow="autoplay; encrypted-media; picture-in-picture"
      sandbox="allow-same-origin allow-scripts"
    ></iframe>
  );
};

const LiveStreamInactive = ({ poster, publishedDate }) => {
  const [countdown, setCountdown] = useState("");

  // Function to format the time with proper pluralization
  const formatTime = (value, unit) => `${value} ${unit}${value !== 1 ? "s" : ""}`;

  useEffect(() => {
    if (publishedDate) {
      const interval = setInterval(() => {
        const now = new Date();
        const publishedTime = new Date(publishedDate);
        const difference = publishedTime - now;

        if (difference > 0) {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

          setCountdown(
            `${formatTime(days, "day")} ${formatTime(hours, "hour")} ${formatTime(
              minutes,
              "minute"
            )}`
          );
        } else {
          setCountdown("");
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [publishedDate]);

  const message =
    publishedDate && countdown ? `Starting in ${countdown}` : "Stream is not active right now";

  return (
    <div className="relative self-center text-center">
      <img src={poster} alt="Stream Inactive" className="w-full h-auto object-cover" />
      <div className="absolute top-0 left-0 w-full h-full flex items-start justify-center pt-10 md:pt-15">
        <div className="text-white text-lg font-bold bg-black bg-opacity-50 p-2 rounded">
          {message}
        </div>
      </div>
    </div>
  );
};

export default LivepeerWrapper;
